module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "AsXT"
    }
  }, [_c('h1', {
    staticClass: "h1a",
    staticStyle: {
      "margin-bottom": "3.7em",
      "margin-top": "5.7em"
    },
    attrs: {
      "id": "pz9-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/loi#d1"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz9-2"
    }
  }, [_vm._v("\n\t\t\t\t\tThis book originated at the InterGenerate Conference held at Lipscomb University\n\t\t\t\t\tin Nashville, Tennessee, in June 2017. So, my gratitude goes to those who made both\n\t\t\t\t\tthe conference and the book a reality. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz9-3"
    }
  }, [_vm._v("\n\t\t\t\t\tThe InterGenerate Task Force, listed below, wishes to express its profound appreciation\n\t\t\t\t\tto both GenOn Ministries"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz11-11a",
      "id": "bl84a"
    }
  }, [_vm._v("1")])]), _vm._v(" and Lipscomb University"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/#pz11-11",
      "id": "bl84"
    }
  }, [_vm._v("2")])]), _vm._v(" who sponsored the conference.\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz9-4"
    }
  }, [_vm._v("\n\t\t\t\t\tGenOn Ministries bathed InterGenerate in prayer, provided initial funding for website\n\t\t\t\t\texpenses, and offered regular promotional support. In addition, at the very beginning,\n\t\t\t\t\tLiz Perraud, executive director of GenOn, created a survey, which she sent to around\n\t\t\t\t\tone hundred people we knew to be interested in intergenerational ministry, to discern\n\t\t\t\t\tthe level of interest for an intergenerational conference; the strong, positive response\n\t\t\t\t\tprovided the impetus to carry the conference vision forward. Several survey respondents\n\t\t\t\t\tbecame part of the task force, along with Shirley Carlson (GenOn board member) and\n\t\t\t\t\tSuzie Lane (GenOn program director). ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz9-5"
    }
  }, [_vm._v("\n\t\t\t\t\tGenerous upfront support from Lipscomb University enabled the InterGenerate task\n\t\t\t\t\tforce to begin their work. These funds were approved by Randy Lowry, president of\n\t\t\t\t\tLipscomb University, and Danny Taylor, Lipscomb’s CFO. Lipscomb’s Hazelip School\n\t\t\t\t\tof Theology and the Institute for Christian Spirituality covered the costs of trademarking\n\t\t\t\t\tthe word "), _c('span', {
    attrs: {
      "id": "z10-6"
    }
  }, [_vm._v("“InterGenerate” and printing the program booklet along with other conference-related\n\t\t\t\t\texpenses. ")])]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-7"
    }
  }, [_vm._v("\n\t\t\t\t\tA special thanks goes to Cory Seibel for his help in editing this text; he offered\n\t\t\t\t\tinvaluable insight and suggestions for two of the chapters—besides the two chapters\n\t\t\t\t\tthat he authored. ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-8"
    }
  }, [_vm._v("\n\t\t\t\t\tAlso, we should acknowledge that two members of the task force, Melissa Cooper (a\n\t\t\t\t\tmillennial) and Olivia Updegrove (a Gen Xer), created the name for the conference\n\t\t\t\t\tand for the book—"), _c('i', [_vm._v("InterGenerate")]), _vm._v("; we are so glad our task force is "), _c('i', [_vm._v("intergenerational")]), _vm._v(".\n\t\t\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-9"
    }
  }, [_vm._v("\n\t\t\t\t\tOn a personal note, I wish to thank the women with whom I meet and pray on Tuesday\n\t\t\t\t\tevenings: Linda Blanks, Linda Bridgesmith, Mary Hemminger, Rebecca Lavender, and\n\t\t\t\t\tKathy Musick. These women have tracked with "), _c('i', [_vm._v("InterGenerate")]), _vm._v(" from the beginning, catching\n\t\t\t\t\tan early glimpse of the vision, listening patiently along the way, holding up my\n\t\t\t\t\thands when challenges surfaced, believing with me that this was God’s work, and sharing\n\t\t\t\t\tthe joy as this work has come to completion. ")]), _vm._v(" "), _c('p', {
    staticClass: "indentv",
    attrs: {
      "id": "pz10-10"
    }
  }, [_vm._v("\n\t\t\t\t\tThe following people formed the InterGenerate Task Force: ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-11"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-1.png",
      "id": "ApQ",
      "src": "images/nec-10-1.png"
    }
  }), _vm._v(" Ron DeVries, Vice-Chair ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-12"
    }
  }, [_vm._v("\n\t\t\t\t\tRegional Catalyzer, Faith Formation Ministries, Alberta, Canada ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-13"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-2.png",
      "id": "AM_K",
      "src": "images/nec-10-2.png"
    }
  }), _vm._v(" John Roberto, Treasurer ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-14"
    }
  }, [_vm._v("\n\t\t\t\t\tVibrant Faith Leadership Team, Naugatuck, Connecticut ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-15"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-3.png",
      "id": "AdL9",
      "src": "images/nec-10-3.png"
    }
  }), _vm._v(" Karen DeBoer, Secretary ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-16"
    }
  }, [_vm._v("\n\t\t\t\t\tCreative Resource Developer, Faith Formation Ministries, Kitchener, Ontario, Canada ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-18"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-4.png",
      "id": "App8",
      "src": "images/nec-10-4.png"
    }
  }), _vm._v(" Melissa Cooper, Website manager ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-19"
    }
  }, [_vm._v("\n\t\t\t\t\tAssociate, Vibrant Faith, Kissimmee, Florida ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-20"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-5.png",
      "id": "AKu",
      "src": "images/nec-10-5.png"
    }
  }), _vm._v(" Shirley Carlson ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-21"
    }
  }, [_vm._v("\n\t\t\t\t\tGenOn Ministries board member, Port Clinton, Ohio ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-22"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-6.png",
      "id": "AOhV",
      "src": "images/nec-10-6.png"
    }
  }), _vm._v(" Darwin Glassford ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-23"
    }
  }, [_vm._v("\n\t\t\t\t\tExecutive Pastor at Harderwyk Ministries in Holland, MI; and Director of Graduate\n\t\t\t\t\tPrograms and Online Learning at Kuyper College, Grand Rapids, Michigan ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz10-26"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-10-7.png",
      "id": "AvZ",
      "src": "images/nec-10-7.png"
    }
  }), _vm._v(" Suzie Lane ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz10-27"
    }
  }, [_vm._v("\n\t\t\t\t\tProgram Director, GenOn Ministries, Nashville, Tennessee ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-11-1.png",
      "id": "ABjB",
      "src": "images/nec-11-1.png"
    }
  }), _vm._v(" Linda Staats ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz11-2"
    }
  }, [_vm._v("\n\t\t\t\t\tHomeGrown Faith, Phoenix, Arizona ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/nec-11-2.png",
      "id": "A3pt",
      "src": "images/nec-11-2.png"
    }
  }), _vm._v(" Olivia Updegrove ")]), _vm._v(" "), _c('p', {
    staticClass: "indentv",
    staticStyle: {
      "margin-left": "2.3em",
      "text-indent": "0em"
    },
    attrs: {
      "id": "pz11-4"
    }
  }, [_vm._v("\n\t\t\t\t\tMinister of Family and Children’s Ministries at Disciples Home Mission, Indianapolis,\n\t\t\t\t\tIndiana ")]), _vm._v(" "), _c('p', {
    staticClass: "indentv",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v("\n\t\t\t\t\tThis hard-working, committed group of people stepped into the idea of convening an\n\t\t\t\t\tintergenerational conference from scratch with passion and panache. Together, we\n\t\t\t\t\trepresent Christians from a number of traditions: Catholic, Churches of Christ, Christian\n\t\t\t\t\tReformed, Disciples of Christ, Methodist, Lutheran, and Presbyterian. It has been\n\t\t\t\t\tone of the most delightful experiences of my life to envision and create something\n\t\t\t\t\tnew with these remarkable people; a wonderful "), _c('i', [_vm._v("esprit de corps")]), _vm._v(" emerged over the eighteen\n\t\t\t\t\tmonths we worked together. Both the conference and this book reflect this amazing\n\t\t\t\t\tspirit, and we learned to say along the way, “To God be the glory.” ")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v("\n\t\t\t\t\tHolly Catterton Allen"), _c('br'), _vm._v("\n\t\t\t\t\tChair, InterGenerate Task Force")]), _vm._v(" "), _c('h5', {
    staticClass: "h5",
    attrs: {
      "id": "AyaR"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "rgb(79,75,76)"
    },
    attrs: {
      "id": "AzV8"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "bibliography",
    attrs: {
      "id": "AU9"
    }
  }, [_c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz11-11a"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#bl84a"
    }
  }, [_vm._v("1")])]), _c('b', [_vm._v("GenOn Ministries:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.genonministries.org",
      "id": "AcFh",
      "target": "_blank"
    }
  }, [_vm._v("www.genonministries.org")]), _vm._v(" GenOn Ministries equips faith communities\n\t\t\t\t\t\tfor Christian discipleship and builds and nurtures relationships with God through\n\t\t\t\t\t\tJesus Christ through intergenerational resources, trainings, conferences, and Youth\n\t\t\t\t\t\tSummits. ")]), _vm._v(" "), _c('p', {
    staticClass: "footnote",
    attrs: {
      "id": "pz11-11"
    }
  }, [_c('sup', [_c('a', {
    attrs: {
      "href": "#/#bl84",
      "id": "anchor_id_1"
    }
  }, [_vm._v("2")])]), _c('b', [_vm._v("Lipscomb University:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.lipscomb.edu",
      "id": "Aqx",
      "target": "_blank"
    }
  }, [_vm._v("www.lipscomb.edu")]), _vm._v(" Lipscomb University is a private Christian\n\t\t\t\t\t\tliberal arts university in Nashville, Tennessee, offering bachelors, masters, and\n\t\t\t\t\t\tdoctoral degrees. Its primary mission is to integrate Christian faith and practice\n\t\t\t\t\t\twith academic excellence. This mission is carried out not only in the classroom but\n\t\t\t\t\t\talso by involvement in numerous services to the church and the larger community.\n\t\t\t\t\t\t("), _c('a', {
    attrs: {
      "href": "http://www.lipscomb.edu/about/mission",
      "id": "A2XA",
      "target": "_blank"
    }
  }, [_vm._v("www.lipscomb.edu/about/mission")]), _vm._v(") ")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a65bbfac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter02.vue
// module id = 72
// module chunks = 0